import * as angular from 'angular';
import * as $ from 'jquery';
import * as _ from 'lodash';
import { chartModule } from '../../chart.module';

chartModule.directive('chartSelector', [
  '$cookies',
  function ($cookies) {
    return {
      scope: {
        view: '=',
        select: '&',
      },
      template:
        '<button class="btn btn-sm btn-select btn-block form-control-sm" ng-click="toggleChartSelectorMenu()">' +
        '<span class="chart-selector-text"><a href="#"><i class="{{ selectedChartIcon() }}"></i>{{ selectedChartName() }}</a></span>' +
        '<i class="icon-dropdown-arrow"></i>' +
        '</button>' +
        '<ul class="chart-selector-menu dropdown-menu">' +
        '<li ng-repeat="chart in charts" ng-hide="chart.type === \'bigNumber\'" ng-class="{\'active\': view.selectedChart == \'{{chart.type}}\' && {{chart.condition || true}}}" ng-disabled="!enabledChart(\'{{chart.type}}\')">' +
        '<a href ng-click="chartSelectHandler($event, chart.type, chart.subtype, chart.icon)"><i class="{{chart.icon}}"></i> {{chart.description}}</a>' +
        '</li>' +
        '<li class="border"></li>' +
        '<li ng-class="{\'show-gallery\': exploreGallery}">' +
        '<a href="https://mode.com/example-gallery?utm_source=product&utm_medium=chart_editor&utm_campaign=gallery" target="_blank" rel="noopener" class="explore-link"><i class="icon-caret-right-white explore-icon"></i> Explore Custom Visualizations</a>' +
        '<div class="explore-gallery">' +
        '<a href="#" class="explore-close icon-x-large-white" ng-click="closeExplore()"></a>' +
        '<div class="explore-content"><i class="icon-gallery-illo gallery-icon"></i>Learn how to make custom visualizations</div>' +
        '<a href="https://mode.com/example-gallery?utm_source=product&utm_medium=chart_editor&utm_campaign=gallery" target="_blank" rel="noopener"><i class="icon-caret-right-white explore-icon"></i> Explore the Gallery</a>' +
        '</div>' +
        '</li>' +
        '</ul>',

      controller: [
        '$scope',
        '$element',
        '$attrs',
        function ($scope, $element, $attrs) {
          $element = $($element[0]);

          $scope.charts = [
            {
              type: 'bar',
              subtype: 'bar',
              description: 'Grouped Bar Chart',
              icon: 'icon-chart-grouped-bar-color',
              condition: '!view.bar.stacked',
              getCondition: function () {
                return !$scope.view.bar.stacked;
              },
              setSubtype: function () {
                $scope.view.bar.stacked = false;
              },
            },
            {
              type: 'bar',
              subtype: 'stackedBar',
              description: 'Bar Chart',
              icon: 'icon-chart-bar-color',
              condition: 'view.bar.stacked',
              getCondition: function () {
                return $scope.view.bar.stacked;
              },
              setSubtype: function () {
                $scope.view.bar.stacked = true;
              },
            },
            {
              type: 'line',
              subtype: 'line',
              description: 'Line Chart',
              icon: 'icon-chart-line-color',
            },
            {
              type: 'linePlusBar',
              subtype: 'linePlusBar',
              description: 'Line + Bar Chart',
              icon: 'icon-chart-linebar-color',
            },
            {
              type: 'area',
              subtype: 'area',
              description: 'Area Chart',
              icon: 'icon-chart-area-color',
              condition: '!view.area.expanded',
              getCondition: function () {
                return !$scope.view.area.expanded;
              },
              setSubtype: function () {
                $scope.view.area.expanded = false;
              },
            },
            {
              type: 'area',
              subtype: 'expandedArea',
              description: '100% Area Chart',
              icon: 'icon-chart-area100-color',
              condition: 'view.area.expanded',
              getCondition: function () {
                return $scope.view.area.expanded;
              },
              setSubtype: function () {
                $scope.view.area.expanded = true;
              },
            },
            {
              type: 'pie',
              subtype: 'pie',
              description: 'Pie Chart',
              icon: 'icon-chart-pie-color',
              condition: '!view.pie.donut',
              getCondition: function () {
                return !$scope.view.pie.donut;
              },
              setSubtype: function () {
                $scope.view.pie.donut = false;
              },
            },
            {
              type: 'pie',
              subtype: 'donut',
              description: 'Donut Chart',
              icon: 'icon-chart-donut-color',
              condition: 'view.pie.donut',
              getCondition: function () {
                return $scope.view.pie.donut;
              },
              setSubtype: function () {
                $scope.view.pie.donut = true;
              },
            },
            {
              type: 'scatter',
              subtype: 'scatter',
              description: 'Scatter Plot',
              icon: 'icon-chart-scatter-color',
            },
            {
              type: 'bigNumber',
              subtype: 'bigNumber',
              description: 'Big Number',
              icon: 'icon-chart-bignumber-color',
            },
          ];

          $scope.exploreGallery = $cookies.get('modeHideExploreGallery') ? false : true;

          function setViewSubtype(chartSubtype) {
            _.each($scope.charts, function (chart) {
              if (chart.subtype === chartSubtype && chart.setSubtype) {
                chart.setSubtype();
              }
            });
          }

          function setChartSelectorValue(chartType: string, chartSubtype: string, icon: string) {
            $scope.select({ type: chartType, subtype: chartSubtype, icon: icon });
          }

          function chartComparator(chart) {
            return (
              $scope.view &&
              $scope.view.selectedChart &&
              $scope.view.selectedChart === chart.type &&
              (!chart.getCondition || chart.getCondition())
            );
          }

          $scope.closeExplore = function () {
            $cookies.put('modeHideExploreGallery', 'true');
            $scope.exploreGallery = false;
          };

          $scope.selectedChartIcon = function () {
            const chart = _.find($scope.charts, chartComparator);
            if (chart) {
              return chart.icon;
            }
          };

          $scope.selectedChartName = function () {
            const chart = _.find($scope.charts, chartComparator);
            if (chart) {
              return chart.description;
            }
          };

          $scope.toggleChartSelectorMenu = function () {
            const $menu = $element.find('.chart-selector-menu');
            $menu.toggleClass('dropdown-open');
            if ($menu.is('.dropdown-open')) {
              $(document).on('click.chartSelectorDocClick', function (e) {
                const $targetEl = $(e.target);
                if ($targetEl.closest('.chart-selector').length === 0) {
                  $scope.toggleChartSelectorMenu();
                }
              });
            } else {
              $(document).off('.chartSelectorDocClick');
            }
          };

          // event delegation prevented by phantomjs event bubbling bug
          // that's why the click handler is not on the <ul>
          $scope.chartSelectHandler = function ($event, type, subtype, icon) {
            $event.preventDefault();

            // set the subtype on the view
            setViewSubtype(subtype);
            // select chart and set dropdown selection
            setChartSelectorValue(type, subtype, icon);
            // hide dropdown menu
            $scope.toggleChartSelectorMenu();
          };
        },
      ],
    };
  },
]);
